export default __webpack_public_path__ + "instagram.103ef0ecc8676f55139fd82d7449ed0f.svg";